import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import { withRouter } from 'react-router-dom';
import { getUser, deleteUser } from '../services/user.service';
import { FormDetailsItem } from '../../common/components';

class UserDetails extends PureComponent {
  state = {
    data: {},
    isLoading: true,
  };

  id = this.props.match.params.id;

  async componentDidMount() {
    const data = await getUser(this.id);

    this.setState({
      data,
      isLoading: false,
    });
  }

  onRemove = async () => {
    const { history } = this.props;

    if (window.confirm('Jesteś pewien, ze chcesz usunąć użytkownika?')) {
      await deleteUser(this.id);

      history.replace('/users');
    }
  }

  onEdit = async () => {
    const { history } = this.props;

    history.replace(`/user/${this.id}`);
  }

  render() {
    const { data, isLoading } = this.state;
    let role;

    if (isLoading) {
      return null;
    }
    switch (data.role) {
      case 0:
        role = 'Administrator';
        break;
      case 1:
        role = 'Pracownik techniczny';
        break;
      case 2:
      default:
        role = 'Klient';
        break;
    }

    return (
      <>
        <div className="content">
          <div className="card-header border row no-gutters justify-content-between align-items-center py-2">
            Szczegóły użytkownika
            <div>
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={this.onRemove}
              >
                Usuń użytkownika
              </button>
              <button
                type="button"
                className="btn btn-outline-primary ml-2"
                onClick={this.onEdit}
              >
                Edycja użytkownika
              </button>
            </div>
          </div>
          <div className="card border rounded-0 border-top-0">
            <div className="card-body border-0">
              <FormDetailsItem label="Imię i nazwisko" value={`${_get(data, 'name')}`} />
              <FormDetailsItem label="Email" value={_get(data, 'email')} />
              <FormDetailsItem label="Rola" value={role} />
              <FormDetailsItem label="Aktywny" value={_get(data, 'active') ? 'Tak' : 'Nie'} />
              <FormDetailsItem label="Firma" value={_get(data, 'company.name')} />
            </div>
          </div>
        </div>
      </>
    );
  }
}

UserDetails.defaultProps = {

};

UserDetails.propTypes = {
  history: PropTypes.objectOf(PropTypes.shape).isRequired,
  match: PropTypes.objectOf(PropTypes.shape).isRequired,
};

export default withRouter(UserDetails);
